// @flow
import React from 'react';
import { IoMdArrowBack } from 'react-icons/io';
import { Link } from 'react-router-dom';
import ScrollToTop from 'components/common/ScrollToTop';
import './ProductsTagCurrent.scss';

type Props = {
  name: string,
  count: ?number,
};

const ProductsTagCurrent = ({ name, count }: Props) => {
  return (
    <div className="ProductsTagCurrent">
      <h2>
        {name}{' '}
        {typeof count === 'number' && (
          <span className="lighten">({count && count.toLocaleString()}개의 포스트)</span>
        )}
      </h2>
    </div>
  );
};

export default ProductsTagCurrent;



// WEBPACK FOOTER //
// ./src/components/tags/ProductsTagCurrent/ProductsTagCurrent.js